import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface DiamondState {
  totalDiamonds: number
}

const initialState: DiamondState = {
  totalDiamonds: 0
}

const diamondCountSlice = createSlice({
  name: 'diamond',
  initialState,
  reducers: {
    setDiamondCount: (state, action: PayloadAction<number>) => {
      state.totalDiamonds = action.payload
    }
  }
})

export const { setDiamondCount } = diamondCountSlice.actions
export default diamondCountSlice.reducer
